export const RBAC_ACTIONS = ["read", "create", "update", "delete"] as const;

export type PermissionAction = typeof RBAC_ACTIONS[number];

export const RBAC_MODULES = [
  { id: "dashboard", label: "Tableau de bord" },
  { id: "drivers", label: "Chauffeurs" },
  { id: "vehicles", label: "Véhicules" },
  { id: "assignments", label: "Affectations" },
  { id: "inspections", label: "Inspections" },
  { id: "damages", label: "Sinistres" },
  { id: "fines", label: "Amendes" },
  { id: "reports", label: "Sinistres" },
  { id: "fuelCards", label: "Cartes carburant" },
  { id: "users", label: "Utilisateurs" },
  { id: "roles", label: "Rôles" },
  { id: "organizations", label: "Organisations" },
  { id: "settings", label: "Paramètres" },
] as const;

export type PermissionModule = typeof RBAC_MODULES[number]["id"];

export interface PermissionMatrixEntry {
  module: PermissionModule;
  actions: Record<PermissionAction, boolean>;
}




